<div class="wrapper mt-[0px] m-[30px] pt-[43px] p-[25px]">
  <div class="bg-[#F3F3F3] header">Project Plan</div>
  <div class="flex justify-end mt-[30px]">
    <button class="secondary-button mr-[7px]" (click)="handleEdit()">Edit</button>
    <button class="print-button" (click)="handleProjectStage2Approval()"
    [ngClass]="{
      
      '!bg-[#197741] !border-[#197741]': approvalDetails.length > 0 && approvalDetails[0]?.parentStatus === 'approved',
      '!bg-[#ff0000] !border-r-[#ff0000]': approvalDetails.length > 0 && approvalDetails[0]?.parentStatus === 'rejected',
    }"
    ><span>{{
      approvalDetails.length > 0
        ? "Approval Status"
        : "Send For Approval"
    }}</span></button>
  </div>
  <!-- NRM Table -->
  <div class="mb-8">
    <div class="flex justify-start gap-[50px] w-[100%] mt-[34px] min-h-[228px]">
      <div class="w-[30%] p-[30px] !text-[24px] project-attributes-container">
        <h1>Measurement Standards and Work Packages</h1>
      </div>
      <div class="w-[70%] flex flex-col justify-center">
        <h1 class="measurement-header">NRM</h1>
        <h3 class="measurement-calculations-head">
          Total Work Packages - {{ total_work_packages }}
        </h3>
        <h3 class="measurement-calculations-head">
          Total Estimated Cost - {{ country?.symbol ? country?.symbol : "$" }}
          {{ total_cost }}
        </h3>
      </div>
    </div>
    <table
      class="min-w-full bg-[#fcfcfd] table-auto border-collapse border-gray-200"
    >
      <thead
        class="h-[50px] bg-[#ececec] text-[#000000] !text-center justify-center"
      >
        <tr>
          <th class="border border-gray-300 px-4 py-2 text-left">Name</th>
          <th class="border border-gray-300 px-4 py-2 text-center">
            Cost Estimate
          </th>
          <th class="border border-gray-300 px-4 py-2 text-left">
            Responsible
          </th>
          <th class="border border-gray-300 px-4 py-2 text-left">
            Accountable
          </th>
          <th class="border border-gray-300 px-4 py-2 text-left">Consulted</th>

          <th class="border border-gray-300 px-4 py-2 text-left">Informed</th>
        </tr>
      </thead>
      <tbody>
        <!-- <ng-container *ngFor="let item of nrmItems"> -->
        <tr *ngFor="let workPackage of nrmItems" class="hover:bg-gray-50">
          <td class="border border-gray-300 px-4 py-2">
            {{ workPackage.work_package?.name }}
          </td>
          <td class="border border-gray-300 px-4 py-2 text-center">
            <input
              class="bg-[#F9FAFB] !text-center"
              [value]="workPackage?.cost_estimate"
              currencyMask
              [options]="{
                prefix: country?.symbol ? country?.symbol : '$',
                suffix: '',
                thousands: ',',
                allowZero: false,
                decimal: '',
                precision: 0,
                nullable: true,
                align: 'left',
                max: 100000000000,
              }"
              disabled
            />
          </td>

          <td class="border border-gray-300 px-4 py-2">
            {{
              workPackage.responsible === "undefined"
                ? ""
                : workPackage.responsible
            }}
          </td>
          <td class="border border-gray-300 px-4 py-2">
            {{
              workPackage.accountable === "undefined"
                ? ""
                : workPackage.accountable
            }}
          </td>
          <td class="border border-gray-300 px-4 py-2">
            {{
              workPackage.consulted === "undefined" ? "" : workPackage.consulted
            }}
          </td>
          <td class="border border-gray-300 px-4 py-2">
            {{
              workPackage.informed === "undefined" ? "" : workPackage.informed
            }}
          </td>
        </tr>
        <!-- </ng-container> -->
      </tbody>
    </table>
  </div>

  <div class="mb-8 mt-[50px]">
    <div class="flex justify-start gap-[50px] w-[100%] mt-[34px] min-h-[228px]">
      <div class="w-[30%] p-[30px] project-attributes-container">
        <h1>Risk Register</h1>
      </div>
      <div class="w-[70%] flex flex-col justify-center">
        <h3 class="measurement-calculations-head">
          Total No. Identified Risks - {{ number_of_risks }}
        </h3>
        <h3 class="measurement-calculations-head">
          Average = {{ average_risks }}, Medium = {{ moderate_risks }}, High =
          {{ high_risks }}
        </h3>
      </div>
    </div>

    <!-- Risk Description Table -->
    <div>
      <table
        class="min-w-full table-auto bg-[#fcfcfd] border-collapse border border-gray-200"
      >
        <thead class="h-[50px] bg-[#ececec] text-[#000000] !text-center">
          <tr>
            <th class="border border-gray-300 px-4 py-2 text-left">
              Risk Description
            </th>
            <th class="border border-gray-300 px-4 py-2 text-center">
              Risk Category
            </th>
            <th class="border border-gray-300 px-4 py-2 text-center">
              Likelihood
            </th>
            <th class="border border-gray-300 px-4 py-2 text-center">Impact</th>
            <th class="border border-gray-300 px-4 py-2 text-center">
              Risk Rating
            </th>
            <th class="border border-gray-300 px-4 py-2 text-left">
              Mitigation Strategy
            </th>
            <th class="border border-gray-300 px-4 py-2 text-left">Owner</th>
            <th class="border border-gray-300 px-4 py-2 text-center">Date</th>
            <th class="border border-gray-300 px-4 py-2 text-left">Status</th>
          </tr>
        </thead>
        <tbody class="">
          <tr
            *ngFor="let risk of riskDescriptions$ | async"
            class="hover:bg-gray-50"
          >
            <td class="border border-gray-300 px-4 py-2">
              {{ risk.description }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{ risk.risk_category_id }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{ risk.likelihood }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{ risk.impact }}
            </td>
            <td
              class="border border-gray-300 px-4 py-2 text-center"
              [ngStyle]="{
                'background-color': risk.risk_rating > 10 ? 'red' : 'green',
                color: 'white'
              }"
            >
              {{ risk.risk_rating }}
            </td>
            <td class="border border-gray-300 px-4 py-2">
              {{ risk.mitigation_strategy }}
            </td>
            <td class="border border-gray-300 px-4 py-2">
              {{ risk.risk_owner }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              {{ risk.target_resolution_date }}
            </td>
            <td class="border border-gray-300 px-4 py-2">
              <span
                [ngClass]="{
                  'text-green-500  px-2 py-1 rounded': risk.status === 'Active',
                  'text-red-500  px-2 py-1 rounded': risk.status === 'Rejected',
                  'text-green-700  px-2 py-1 rounded':
                    risk.status === 'Approved',
                  'text-gray-500 px-2 py-1 rounded': risk.status === 'Inactive'
                }"
              >
                {{ risk.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <app-approval-status-view
    [projectId]="projectId"
    [stage]="PROJECT_STAGE?.STAGE_2"
  ></app-approval-status-view>
</div>
